require('./bootstrap');

var initSlide = function () {

    $(document).on("click", ".scroll", function (e) {
        e.preventDefault();


        var offset = $(this).attr("data-offset");

        if (typeof offset !== undefined && offset !== false && !isNaN(offset)) {
            offset = parseInt(offset);
        } else {
            offset = -50;
        }

        if ($(this).attr("href") !== undefined) {
            const href = $(this).attr("href");
            var slideTo = window.location.pathname === '/' ? href.substring(href.indexOf("#")) : href
        } else {
            var slideTo = $(this).attr("data-to-slide");
        }
        //console.log("slideto:" + slideTo);

        var scroll_px = $(slideTo).offset().top + offset;

        //console.log("bum: px:" + scroll_px);
        $('html,body').animate({scrollTop: scroll_px}, 'slow');
    });
};

$(document).ready(function () {
    initSlide();

    $("body").scrollspy({
        target: '#nav',
        offset: 60
    });

    $(".slick-container").on('init', function (event, slick, currentSlide, nextSlide) {
        slick.slickGoTo(2)
    });

    $(".slick-container").slick({
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        centerMode: true,

        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    arrows: false,
                    centerMode: true,
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 768,
                settings: {
                    arrows: false,
                    centerMode: true,
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    arrows: false,
                    centerMode: true,
                    slidesToShow: 1
                }
            }
        ]
    })
});
